import React, { ReactElement } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';

import Icon, { faLink } from '~components/icon';
import Spinner from '~components/Spinner';

interface ComponentProps {
  label: string;
  type?: string;
  value?: number | null;
  loading?: boolean | null;
  error?: string | null;
  url?: string | null;
}

const linkWrapper = (element: ReactElement, url: string) => {
  return url ? (
    <a href={url} className="snapshot-link">
      {element} <Icon className="snapshot-icon" icon={faLink} />
    </a>
  ) : (
    element
  );
};

const Snapshot: React.FC<ComponentProps> = ({ label, value, loading, error, url }) => {
  return (
    <div className="snapshot-container">
      <Card>
        <CardHeader>{label || 'Snapshot'}</CardHeader>
        <CardBody>
          {loading && <Spinner size={10} loading={loading} className="m-2" />}
          {!loading && error && <div className="text-danger">Error: {error}</div>}
          {!loading && !error && linkWrapper(<div>{value}</div>, url ?? '')}
        </CardBody>
      </Card>
    </div>
  );
};

export default Snapshot;
